import React from 'react';
import Translate from 'react-translate-component';

import { history } from 'store/browserHistory';
import { approvalPerson, approvalProject } from 'constants/routes';

const pathes = { approvalPerson, approvalProject };

const approvalNotifications = (type) => {
    const redirect = (closeNotification) => {
        history.push(pathes[type].stringify({ status: 'inwork' }));
        closeNotification();
    }

    return function ApprovalNotifications ({ count, closeNotification }) {
        return count ? (
            <div className='notification-link' onClick={() => redirect(closeNotification)}>
                <Translate content={`notify.${type}`} with={{ count }} />
            </div>
        ) : null;
    };
}

export const ApprovalPersonNotification = approvalNotifications('approvalPerson');
export const ApprovalProjectNotification = approvalNotifications('approvalProject');
